<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row>
        <v-flex xs12 sm10 md6 offset-sm1 offset-md3>
          <v-flex xs12 sm10 md8 offset-sm1 offset-md2 align-center justify-center text-xs-center class="mb-5">
            <img src="@/assets/logo.png" alt="WikiSchool.Asia" class="mb-5">
            <blockquote>
              &#8220;First, solve the problem. Then, write the code.&#8221;
              <footer>
                <small>
                  <em>&mdash;John Johnson</em>
                </small>
              </footer>
            </blockquote>
          </v-flex>

          <v-flex xs12 sm10 md8 offset-sm1 offset-md2 align-center justify-center text-xs-center class="mb-3">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card class="elevation-12">
                <v-card-text>
                  <v-text-field v-model="qrcode" :rules="qrcodeRules" label="ស្វែងរកដោយ QR កូដ" class="mb5" required></v-text-field>
              </v-card-text>              
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="!valid" @click="submit">ស្វែងរក</v-btn>
                <v-btn @click="clear">clear</v-btn>
              </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-flex>
        
      </v-layout>      
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      qrcode: '',
      valid: true,
      qrcodeRules: [
        v => !!v || 'QR កូដត្រូវមាន',
        v => (v && v.length === 36) || 'QR កូដដែលដាក់មានទំហំមិនត្រឹមត្រូវ',
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$router.push(`/${this.qrcode}`);
      }
    },
    clear() {
      this.$refs.form.reset();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.khmer .v-messages {
  height: 25px !important;
  line-height: 22px !important;
}
.khmer .v-input .v-label {
  font-size: 1rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homePage.vue